function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useCallback, useState } from 'react';
import Dropdown from '@rd-web-markets/shared/dist/util/Dropdown';
import { Loader } from '@rd-web-markets/shared/dist/util/Loader';
import IsNotSaved from '../IsNotSaved';
import furtherRequirementService from '../../../services/company/further_requirement.service';
import { useTranslation } from 'react-i18next';
import FurtherRequirementDocumentUploadModal from './FurtherRequirementDocumentUploadModal';
import { CloudUploadButton } from '@rd-web-markets/shared/dist/util/buttons/CloudUploadButton';
import { DeleteButton } from '@rd-web-markets/shared/dist/util/buttons';
const FR_OPTIONS = [{
  key: 'yes',
  value: 'true',
  text: 'yes'
}, {
  key: 'no',
  value: 'false',
  text: 'no'
}];
const VERSION_7_FIELD_GROUPS = [{
  key: 'fr_1_1',
  label: 'fr_1_1'
}, {
  key: 'fr_1_2',
  label: 'fr_1_2'
}, {
  key: 'fr_1_3',
  label: 'fr_1_3'
}];
const VERSION_8_FIELD_GROUPS = [{
  key: 'fr_1_1',
  label: 'fr_1_1'
}, {
  key: 'fr_1_2',
  label: 'fr_1_2'
}, {
  key: 'fr_1_3',
  label: 'fr_1_3_v8'
}, {
  key: 'fr_1_4',
  label: 'fr_1_4'
}, {
  key: 'fr_1_5',
  label: 'fr_1_5'
}, {
  key: 'fr_1_6',
  label: 'fr_1_6'
}, {
  key: 'fr_1_7',
  label: 'fr_1_7'
}, {
  key: 'fr_1_8',
  label: 'fr_1_8'
}, {
  key: 'fr_1_9',
  label: 'fr_1_9'
}, {
  key: 'fr_1_10',
  label: 'fr_1_10'
}];
const toSelectString = v => {
  if (v === true || v === 'true') return 'true';
  if (v === false || v === 'false') return 'false';
  return '';
};
const fromSelectString = val => {
  if (val === '' || val == null) return null;
  if (val === 'true') return true;
  if (val === 'false') return false;
  return null;
};
const documentsForField = (furtherRequirement, fieldKey) => {
  var _furtherRequirement$f;
  return ((_furtherRequirement$f = furtherRequirement === null || furtherRequirement === void 0 ? void 0 : furtherRequirement.further_requirement_documents) !== null && _furtherRequirement$f !== void 0 ? _furtherRequirement$f : []).filter(d => d.further_requirement_field === fieldKey);
};
const FurtherRequirements = _ref => {
  let {
    elster
  } = _ref;
  const {
    t
  } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [isNotSaved, setIsNotSaved] = useState(false);
  const [showUploadModal, setShowUploadModal] = useState(false);
  const isVersion8 = (elster === null || elster === void 0 ? void 0 : elster.version_number) === 'version_8';
  const {
    furtherRequirement,
    setFurtherRequirement,
    updateFurtherRequirement,
    uploadDocuments,
    deleteDocuments
  } = furtherRequirementService.useCrud(elster === null || elster === void 0 ? void 0 : elster.id, setLoading);
  const saveData = useCallback(async body => {
    await updateFurtherRequirement({
      further_requirement: body
    });
    setIsNotSaved(false);
  }, [updateFurtherRequirement]);
  const renderField = field => /*#__PURE__*/React.createElement(Dropdown, {
    key: field.key,
    name: field.key,
    fieldName: field.key,
    label: field.label,
    value: toSelectString(furtherRequirement === null || furtherRequirement === void 0 ? void 0 : furtherRequirement[field.key]),
    onChange: val => {
      setFurtherRequirement(prev => _objectSpread(_objectSpread({}, prev || {}), {}, {
        [field.key]: fromSelectString(val)
      }));
      setIsNotSaved(true);
    },
    options: FR_OPTIONS,
    dataTestId: "further_requirement_".concat(field.key),
    labelColSpan: 6,
    showNullOption: true
  });
  if (loading && furtherRequirement == null) {
    return /*#__PURE__*/React.createElement(Loader, null);
  }
  const fieldGroups = isVersion8 ? VERSION_8_FIELD_GROUPS : VERSION_7_FIELD_GROUPS;
  return /*#__PURE__*/React.createElement(React.Fragment, null, fieldGroups.map((field, index) => /*#__PURE__*/React.createElement(React.Fragment, {
    key: 'further_requirement_' + field.key
  }, field.key === 'fr_1_1' && /*#__PURE__*/React.createElement("h2", {
    className: "mb-3".concat(index > 0 ? ' mt-4' : '')
  }, t('title_further_requirements')), field.key === 'fr_1_5' && /*#__PURE__*/React.createElement("h2", {
    className: "mb-3".concat(index > 0 ? ' mt-4' : '')
  }, t('tk_freq_4_1')), renderField(field), documentsForField(furtherRequirement, field.key).map(frDoc => {
    var _frDoc$document;
    return /*#__PURE__*/React.createElement("div", {
      key: frDoc.id,
      className: "mb-2"
    }, ((_frDoc$document = frDoc.document) === null || _frDoc$document === void 0 ? void 0 : _frDoc$document.url) && /*#__PURE__*/React.createElement("a", {
      href: frDoc.document.url,
      target: "_blank",
      rel: "noreferrer"
    }, frDoc.document.filename), /*#__PURE__*/React.createElement(DeleteButton, {
      onClick: () => deleteDocuments({
        furtherRequirementDocumentId: frDoc.id
      })
    }));
  }), field.key === 'fr_1_1' && /*#__PURE__*/React.createElement(CloudUploadButton, {
    variant: "primary",
    disabled: !(furtherRequirement !== null && furtherRequirement !== void 0 && furtherRequirement.id),
    onClick: () => setShowUploadModal(true),
    text: t('upload_relevant_documents')
  }))), /*#__PURE__*/React.createElement(FurtherRequirementDocumentUploadModal, {
    show: showUploadModal,
    onHide: () => setShowUploadModal(false),
    uploadDocuments: uploadDocuments
  }), /*#__PURE__*/React.createElement(IsNotSaved, {
    isNotSaved: isNotSaved,
    save: saveData,
    paramsForUpdate: [furtherRequirement],
    loading: loading
  }));
};
export default FurtherRequirements;